<section class="sav-about-hero" aria-label="About SavingArena">
  <div class="sav-site-container">
    <app-breadcrumb [items]="crumbs" />
    <div class="sav-about-hero-inner">
      <span class="sav-about-eyebrow">About SavingArena</span>
      <h1 class="sav-about-title">{{ h1() }}</h1>
      <p class="sav-about-subtitle">{{ shortDescription() }}</p>
    </div>
  </div>
</section>

@if (stats().length > 0) {
  <section class="sav-about-stats-section" aria-label="SavingArena by the numbers">
    <div class="sav-site-container">
      <div class="sav-about-stats">
        @for (stat of stats(); track stat.label + $index) {
          <div class="sav-about-stat">
            <strong>{{ stat.value }}</strong>
            <span>{{ stat.label }}</span>
          </div>
        }
      </div>
    </div>
  </section>
}

<section class="sav-about-story-section" aria-label="Our story">
  <div class="sav-site-container">
    <div class="sav-about-story">
      <div class="sav-longform-cms" [innerHTML]="contentHtml() | trustedCmsHtml"></div>
    </div>
  </div>
</section>

@if (values().length > 0) {
  <section class="sav-about-values-section" aria-label="Why shoppers choose us">
    <div class="sav-site-container">
      <div class="sav-about-values-head">
        <span class="sav-about-eyebrow">Why shoppers choose us</span>
        <h2 class="sav-about-values-title">Built on trust, honesty and real savings</h2>
        <p>The principles behind every offer we publish.</p>
      </div>
      <div class="sav-about-values-grid">
        @for (value of values(); track value.title + $index) {
          <article class="sav-about-value-card">
            <span class="sav-about-value-icon" aria-hidden="true">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </span>
            <h3>{{ value.title }}</h3>
            @if (value.description) {
              <p>{{ value.description }}</p>
            }
          </article>
        }
      </div>
    </div>
  </section>
}

<app-big-sale-banner />
